import * as React from 'react';
import * as  moment from 'moment';
import * as _ from 'lodash';
import { AnalyticsChartPeriods } from '../../../services/mini/analytics/analyticsChartPeriods';
import { DatePickerLabel } from './DatePickerLabel';
import DatePickerPopup from './DatePickerPopup';

type CustomDatePickerProps = {
    period: AnalyticsChartPeriods,
    startDate: number,
    endDate: number,
    startFromDate: number,
    onChange: () => void,
};
type CustomDatePickerState = {
    showCustomCalendar: boolean;
};

export class CustomDatePicker extends React.PureComponent<CustomDatePickerProps, CustomDatePickerState> {

    constructor(props) {
        super(props);

        this.state = {
            showCustomCalendar: false
        };
    }
    showCustomDatePicker = () => {
        this.setState({ showCustomCalendar: true });
    }

    render() {
        const { period, startDate, endDate, startFromDate } = this.props;
        const { showCustomCalendar } = this.state;

        return <div className="custom-date-picker">
            <div>
                <DatePickerLabel
                    period={period}
                    value={`${new Date(startDate)} - ${endDate ? new Date(endDate) : ''}`}
                    onClick={this.showCustomDatePicker} />
            </div>
            {showCustomCalendar &&
                <div className={`custom-date-picker__body ${period === AnalyticsChartPeriods.Daily ? 'calendar' : 'list'}`}>
                    <DatePickerPopup
                        period={period}
                        startFromDate={startFromDate}
                        startDate={startDate}
                        endDate={endDate}
                        onChange={this.props.onChange}
                        onOutsideClick={() => {
                            this.setState({ showCustomCalendar: false });
                        }}
                    />
                </div>}
        </div>;
    }
}